module.exports = __webpack_public_path__ + "static/media/Q9-9.ef8478cd.jpg";